import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ConversionJobIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M11.3998 21.5998H5.39981C4.07432 21.5998 2.99981 20.5253 2.99982 19.1998L2.99991 4.79989C2.99992 3.47441 4.07443 2.3999 5.39991 2.3999H16.2002C17.5257 2.3999 18.6002 3.47442 18.6002 4.7999V9.5999M16.8002 16.1399V16.0767M21.0002 16.1909C21.0002 16.1909 20.004 19.1306 16.8002 19.0792C13.5963 19.0279 12.6002 16.1909 12.6002 16.1909C12.6002 16.1909 13.556 13.1999 16.8002 13.1999C20.0444 13.1999 21.0002 16.1909 21.0002 16.1909Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

ConversionJobIcon.displayName = 'ConversionJobIcon';
